import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import ConsentCheckboxes from './ConsentCheckboxes';

const AiConsentModal = ({
  isOpen,
  part1Checked,
  part2Checked,
  onPart1Change,
  onPart2Change,
  onConfirm,
  onDecline,
}) => {
  const { t } = useTranslation();
  const canConfirm = part1Checked && part2Checked;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-[1100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="ai-consent-title"
        >
          <motion.div
            className="bg-white rounded-2xl p-5 sm:p-7 max-w-md w-full shadow-2xl border border-border max-h-[90vh] overflow-y-auto"
            initial={{ scale: 0.92, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.92, opacity: 0, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          >
            <div className="text-center mb-4">
              <div className="w-14 h-14 mx-auto mb-3 bg-primary/10 rounded-full flex items-center justify-center">
                <Sparkles className="w-7 h-7 text-primary" aria-hidden="true" />
              </div>
              <h2
                id="ai-consent-title"
                className="text-lg sm:text-xl font-bold text-foreground"
              >
                {t('ai_consent_title', 'Before you use AI search')}
              </h2>
              <p className="mt-1.5 text-xs sm:text-sm text-muted-foreground leading-relaxed">
                {t(
                  'ai_consent_intro',
                  'All Animal App uses Google Gemini AI to generate animal-welfare results. Please confirm the following to continue.'
                )}
              </p>
            </div>

            <ConsentCheckboxes
              idPrefix="gate-consent"
              part1Checked={part1Checked}
              part2Checked={part2Checked}
              onPart1Change={onPart1Change}
              onPart2Change={onPart2Change}
            />

            <div className="flex flex-col-reverse sm:flex-row gap-3 mt-6">
              <Button
                variant="outline"
                onClick={onDecline}
                className="flex-1 h-11"
              >
                {t('cancel', 'Cancel')}
              </Button>
              <Button
                onClick={onConfirm}
                disabled={!canConfirm}
                className="flex-1 h-11"
              >
                {t('agree_and_continue', 'Agree & continue')}
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AiConsentModal;
